import React, { useEffect, useState } from 'react';

const Message = ({ type, message }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (message) {
      setVisible(true);
      const timer = setTimeout(() => setVisible(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  if (!visible || !message) return null;

  return (
    <div className={`message ${type}`}>
      {message}
    </div>
  );
};

export default Message;